import { defineStore } from 'pinia'
import profile from "@/network/profile";

export const useAuthorityStore = defineStore('authority', {
  state: () => {
    return {
      UserInfo: {},//用户信息
      RolesFunctionList: {},//用户权限
      RolesNames: [], // 用户角色
    }
  },
  actions: {
    //判断用户是否权限
    GetAuthority (data) {
      if (this.RolesFunctionList[data]) {
        return true;
      } else {
        return false;
      }
    },
    //设置保存用户信息和权限
    async SetAuthData () {
      var result = await profile
        .GetUserInfo()
        .then((res) => res);
      if (result.status == 200) {
        this.RolesFunctionList = result.data.rolesFunctionList;
        this.UserInfo = result.data.userInfo;
        this.RolesNames = result.data.rolesNames
      }
    },
    isSalesAdmin () {
      return this.bHasRole("BBSalesAdmin")
    },
    isOrderTop () {
      return this.RolesFunctionList.Form_Order_Top_read;
    },
    isSales () {
      return this.bHasRole("BBSalesman") || this.bHasRole("BBTeamHead") || this.bHasRole("BBSalesHead");
    },
    bHasRole (name) {
      return this.RolesNames?.filter(t => t === name).length > 0
    },
    bHasRoleFunctionList (value) {
      return Object.keys(this.RolesFunctionList).filter(t => t === value).length > 0
    },
    isSuperAdmin () {
      return this.bHasRole("SuperAdmin")
    }
  },
  // 所有数据持久化
  persist: true,
  // 持久化存储插件其他配置
  // persist: {
  //   // 修改存储中使用的键名称，默认为当前 Store的 id
  //   key: 'authority',
  //   // 修改为 sessionStorage，默认为 localStorage
  //   storage: localStorage,
  //   // 部分持久化状态的点符号路径数组，[]意味着没有状态被持久化(默认为undefined，持久化整个状态)
  //   paths: ["UserInfo","RolesFunctionList"],
  // },
})
